import { useEffect } from 'react';
import seoData from '../data/seoData.json';

const SEO = () => {
  useEffect(() => {
    // 1. Update Title
    document.title = seoData.title;

    // Helper to add or update Meta Tags
    const setMetaTag = (name, content, attribute = 'name') => {
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // 2. Standard SEO Meta Tags
    setMetaTag('description', seoData.description);
    setMetaTag('keywords', seoData.keywords.join(', '));
    setMetaTag('author', seoData.author);

    // 3. Open Graph (OG) Tags for Social Media (Facebook, WhatsApp, LinkedIn)
    setMetaTag('og:title', seoData.title, 'property');
    setMetaTag('og:description', seoData.description, 'property');
    setMetaTag('og:type', seoData.ogType, 'property');
    
    // Optional: Twitter Card SEO
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', seoData.title);
    setMetaTag('twitter:description', seoData.description);

    // Set HTML language attribute
    document.documentElement.lang = seoData.language;
    
  }, []);

  return null; // This component doesn't render anything in the UI
};

export default SEO;
